import './index.scss';

class Expand extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * @property {HTMLElement} buttonNode - The button element that toggles the controlled content
   * @property {HTMLElement} controlledNode - The content element that is expanded or collapsed
   */
  connectedCallback() {
    this.buttonNode = this.nextElementSibling;
    if (!this.buttonNode.matches(`[aria-controls=${this.buttonNode.getAttribute('aria-controls')}]`)) {
      console.error('Button node not found for Expand component.');
      return;
    }

    this.controlledNode = this.querySelector(`#${this.buttonNode.getAttribute('aria-controls')}`);
    if (!this.controlledNode) {
      console.error('Controlled node not found for Expand component.');
      return;
    }

    this.buttonNode.addEventListener('click', this.toggleExpand.bind(this));

    // Initialiser le calcul de visibilité
    this.updateButtonVisibility();

    // Observer les changements de taille pour gérer les cas où le composant
    // est chargé dans une popin cachée (scrollHeight = 0 initialement)
    this.resizeObserver = new ResizeObserver(() => {
      this.updateButtonVisibility();
    });
    this.resizeObserver.observe(this.controlledNode);
  }

  /**
   * @description Update button visibility based on content height
   */
  updateButtonVisibility() {
    const contentHeight = this.controlledNode.scrollHeight;
    const maxHeight = 150;

    // Ne masquer le bouton que si on a une hauteur valide (> 0)
    // Cela évite de masquer le bouton quand l'élément n'est pas encore rendu
    if (contentHeight > 0) {
      this.buttonNode.classList.toggle('--hidden', contentHeight < maxHeight);
    }
  }

  /**
   * @description Clean up when component is removed
   */
  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.buttonNode) {
      this.buttonNode.removeEventListener('click', this.toggleExpand.bind(this));
    }
  }

  /**
   * @description Toggle the expanded or collapsed state of the controlled content
   */
  toggleExpand() {
    const isExpanded = this.buttonNode.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.hideContent() : this.showContent();
  }

  /**
   * @description Expand the controlled content
   */
  showContent() {
    this.controlledNode.parentNode.classList.add('--expanded');
    this.buttonNode.setAttribute('aria-expanded', 'true');

    // when expanded, the keyboard focus must be positioned on the element that has been displayed
    // and hidden content must be rendered by ATs or accessible by keyboard
    //this.controlledNode.removeAttribute('inert');    !! Pour le mégaMenu a rediscuter avec l'équipe
    this.controlledNode.setAttribute('tabindex', '-1');
    this.controlledNode.focus();
  }

  /**
   * @description Collapse the controlled content
   */
  hideContent() {
    this.controlledNode.parentNode.classList.remove('--expanded');
    this.buttonNode.setAttribute('aria-expanded', 'false');

    // when collapsed, hidden content must not be rendered by the ATs or accessible by keyboard
    //this.controlledNode.setAttribute('inert', '');      !! Pour le mégaMenu a rediscuter avec l'équipe
    this.controlledNode.removeAttribute('tabindex');
  }
}

customElements.get('f-expand') || customElements.define('f-expand', Expand);
